<script setup lang="ts">
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { AppButton, SemboHotelUpsell } from '@libs/ui';
import type { IngredientId } from '@libs/trip-planner-interfaces';

import { useTripOverviewPageStore } from '../../stores';

interface AddHotelBannerProps {
  ingredientId: IngredientId;
}

const props = defineProps<AddHotelBannerProps>();
const statsigEventsStore = useStatsigEventsStore();
const tripOverviewPageStore = useTripOverviewPageStore();

function addHotel(): void {
  tripOverviewPageStore.addAccommodationToOwnStayIngredient(props.ingredientId);
  statsigEventsStore.logTripOverviewAccommodationUpsellHotelAdded();
}
</script>

<template>
  <div class="add-hotel-banner-wrapper">
    <div class="add-hotel-banner">
      <div class="content">
        <div class="icon">
          <SemboHotelUpsell />
        </div>
        <div class="description">
          <div class="label">
            {{ $t('planner.upsell.title') }}
          </div>
          <div class="text">
            {{ $t('planner.upsell.text') }}
          </div>
        </div>
      </div>

      <div class="action">
        <AppButton
          type="secondary"
          size="small"
          :left-icon="{ name: 'plus', size: '18' }"
          state="enabled"
          @click="addHotel"
        >
          {{ $t('planner.upsell.action') }}
        </AppButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.add-hotel-banner-wrapper {
  padding-left: var(--spacing-12);
  display: flex;

  .add-hotel-banner {
    width: 100%;
    display: flex;
    align-items: center;
    padding: var(--spacing-24);
    gap: var(--spacing-12);
    border-radius: var(--border-radius-12);
    background-color: var(--color-brand-lilac);

    justify-content: flex-start;

    @include for-less-or-equal-than-599-px {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--spacing-8);
    }

    .content {
      display: flex;
      justify-content: flex-start;
      gap: var(--spacing-12);
      align-items: center;
      flex: 1;

      .description {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-8);

        .label {
          @include font-label-l-bold;
        }

        .text {
          @include font-body-m-light;
        }
      }
    }

    .action {
      @include for-less-or-equal-than-599-px {
        margin-left: 45px;
      }
    }
  }
}
</style>
